import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "projectName",
  class: "label"
}, "Nome do Projeto", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button",
    type: "submit"
  }, "Salvar")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectName) = $event)),
          id: "projectName"
        }, null, 512), [
          [_vModelText, _ctx.projectName]
        ])
      ]),
      _hoisted_3
    ], 32)
  ]))
}